<template functional>
  <div class="w-full py-6 box-border relative">
    <header class="pl-5 pr-4 border-l-4 border-solid border-theme text-medium-x text-theme-black-850 font-semibold">
    <span v-custom="'out_D74'">调研工厂</span>的优势：
    </header>
    <ul class="pt-1 pl-6 pr-4 mt-1 flex flex-col box-border text-theme-black-850 leading-22">
      <li class="my-1 flex">
        <i class="el-icon-success mt-1 text-green-theme"></i>
        <p class="ml-1 text-medium">快速回收：2000 份答卷最快只需半天。</p>
      </li>
      <li class="my-1 flex">
        <i class="el-icon-success mt-1 text-green-theme"></i>
        <p class="ml-1 text-medium">样本丰富：百万样本库，8 类细分标签，全面覆盖。</p>
      </li>
      <li class="my-1 flex">
        <i class="el-icon-success mt-1 text-green-theme"></i>
        <p class="ml-1 text-medium">专业可靠：12 年专业调研经验、超 8000 万次调查项目执行。</p>
      </li>
      <li class="my-1 flex">
        <i class="el-icon-success mt-1 text-green-theme"></i>
        <p class="ml-1 text-medium">品控保障：通过定位、限时、动线追踪等智能化数据保真。</p>
      </li>
    </ul>
    <div class="absolute bottom-0 w-full h-px px-6 box-border" v-if="props.border">
      <div class="w-full f-full border-b border-solid border-border-gray" />
    </div>
  </div>
</template>

<script>
import { propMixins } from '@/mixins/publish';

export default {
  name: 'SampleServiceStrengths',
  functional: true,
  mixins: [propMixins],
}
</script>